import delegate from '../../00-utilities/delegate';

/**
 * DropdownBase
 */
export default class DropdownBase {
  /**
   * Add click event listener on BODY
  */
  addListenerOnBodyClick() {
    this.bodyListener = this.onClickBody.bind(this);
    document.body.addEventListener('click',this.bodyListener);
  }

  /**
   * Remove click event listener on BODY
  */
  removeListenerOnBodyClick() {
    document.body.removeEventListener('click',this.bodyListener);
    this.bodyListener = null;
  }

  /**
   * Toggle .dropdown__content on .dropdown__trigger click
   * @param {Object} Event
  */
  onClickDropdownHeader(e) {
    if(document.querySelector('.dropdown.js--active') ){
      return true;
    }
    e.stopPropagation();
    if(!this.bodyListener) {
      e.target.parentElement.classList.add('js--active');
      this.addListenerOnBodyClick();
      // Get Transition duration
      const dropdownContent = e.target.nextElementSibling;
      this.setOnTimeOutTransitionEndDropdownContent(dropdownContent);
    }
  }


  /**
   * Close .dropdown__content on body click
   * @param {Object} Event
  */
  onClickBody(e) {
    const activeDropdown = document.querySelector('.js--active.dropdown');
    const dropdownContent = activeDropdown.querySelector('.dropdown__content');
    // Check if a select is active
    if(activeDropdown) {
      // Close the select
      activeDropdown.classList.remove('js--active');
    }

    this.removeListenerOnBodyClick();
    this.setOnTimeOutTransitionEndDropdownContent(dropdownContent);
  }

  /**
   * Toggle class .js--scroll-enabled on .dropdown__content
   * @param {HTMLElement} dropdownContent
   */
  onTimeOutTransitionEndDropdownContent(dropdownContent) {
    dropdownContent.classList.toggle('js--scroll-enabled');
  }

  /**
   * Get transition duration from dropdownContent and setTimer
   * @param {HTMLElement}
   */
  setOnTimeOutTransitionEndDropdownContent(dropdownContent) {
    const animationDelay = parseFloat(getComputedStyle(dropdownContent)['transitionDuration']) * 1000;
    setTimeout(this.onTimeOutTransitionEndDropdownContent.bind(this, dropdownContent), animationDelay);
  }

  /**
   * Set min width to parent
   * @param {HTMLElement}
   */
  setMinWidthToParent() {
    let dropdowns = document.querySelectorAll('.dropdown');
    for(let ii = 0 ; ii < dropdowns.length; ii++) {
      dropdowns[ii].parentElement.style.minWidth = "1px"
    }
  }


}
